import React, { useEffect, useMemo, useState } from 'react';
import {
  LinkIcon,
  CircleStackIcon,
  CubeIcon,
  ChartBarIcon,
  Squares2X2Icon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import ArchitectureTabNav from '../../components/architecture/ArchitectureTabNav';
import ConnectorsTab from '../../components/architecture/ConnectorsTab';
import ArchitectureTab from '../../components/architecture/ArchitectureTab';
import CanonicalModelTab from '../../components/architecture/CanonicalModelTab';
import ContextualKpisTab from '../../components/architecture/ContextualKpisTab';
import DocumentationTab from '../../components/architecture/DocumentationTab';
import {
  ARCHITECTURE_TABS,
  ARCHITECTURE_TAB_ORDER,
} from '../../config/architectureConfig';

const CONNECTORS_TAB_ID = 'connectors';
const MODELS_TAB_ID = 'models';
const ANALYTICS_TAB_ID = 'analytics';
const DOCUMENTATION_TAB_ID = 'documentation';

// Heroicons used by the tab nav, keyed by config tab id.
const TAB_NAV_ICONS = {
  databases: CircleStackIcon,
  models: CubeIcon,
  analytics: ChartBarIcon,
  ux: Squares2X2Icon,
  documentation: DocumentTextIcon,
};

const Architecture = () => {
  const [activeTab, setActiveTab] = useState(CONNECTORS_TAB_ID);

  useEffect(() => {
    document.title = 'Architecture · Pulse Demo';
  }, []);

  // Connectors stays the first tab; the 4 config-driven tabs come after.
  const tabs = useMemo(
    () => [
      { id: CONNECTORS_TAB_ID, name: 'Connectors', icon: LinkIcon },
      ...ARCHITECTURE_TAB_ORDER.map((id) => ({
        id,
        name: ARCHITECTURE_TABS[id].name,
        icon: TAB_NAV_ICONS[id] || CubeIcon,
      })),
    ],
    []
  );

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    if (activeTab === CONNECTORS_TAB_ID) return <ConnectorsTab />;
    if (activeTab === MODELS_TAB_ID) return <CanonicalModelTab />;
    if (activeTab === ANALYTICS_TAB_ID) return <ContextualKpisTab />;
    if (activeTab === DOCUMENTATION_TAB_ID) return <DocumentationTab />;
    const config = ARCHITECTURE_TABS[activeTab];
    return <ArchitectureTab config={config} />;
  };

  return (
    <div className="page-wrapper">
      <div className="layout-container">
        <ArchitectureTabNav
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />

        <div className="p-6">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Architecture;
